module Hereabout.UI.Calendar where

import Prelude

import Data.DateTime as DT
import Data.Int (toNumber)
import Data.JSDate (JSDate)
import Data.JSDate as JSD
import Data.Maybe (fromJust)
import Data.Time.Duration (Seconds(..))
import Effect (Effect)
import Hereabout.Types (EventWithComments(..))
import Partial.Unsafe (unsafePartial)
import Web.HTML (HTMLElement)

type CalendarEvent =
  { id :: String
  , title :: String
  , start :: JSDate
  , end :: JSDate
  }

foreign import data Calendar :: Type

foreign import _createCalendar :: HTMLElement -> Array CalendarEvent -> Effect Calendar

createEventCalendar :: HTMLElement -> EventWithComments String -> Effect Calendar
createEventCalendar elem eventWithC = _createCalendar elem (eventWithCommentsToCalendarEvents eventWithC)

eventWithCommentsToCalendarEvents :: EventWithComments String -> Array CalendarEvent
eventWithCommentsToCalendarEvents (EventWithComments ewc) =
  map mapper ewc.eventInstances
  where
    mapper timestamp =
      { id : ewc.id
      , title : ewc.name
      , start : JSD.fromDateTime timestamp
      , end :  JSD.fromDateTime $ unsafePartial $ fromJust $ DT.adjust (Seconds $ toNumber ewc.duration) timestamp
      }



